<template>
  <form>
    <div class="form-group">
      <label for="exampleInputEmail1">Sujet :</label>
      <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
    </div>
    <div class="form-group">
      <label for="exampleFormControlTextarea1">Message :</label>
      <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
    </div>
    <button type="submit" class="btn btn-outline-success">Envoyer</button>
  </form>
</template>

<script>
export default {
  name: "EnvoisMessage"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > label{
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utilisateurs/components/EnvoisMessage.vue